export const dashConstants = {
    APP_NAME : 'Github Dynamic Quotes for Readme'
};